<template>
  <!-- 首页中部banner横幅 -->
  <div class="homebanner2 text_center">
    <div class="b2_title">律观网</div>
    <div class="b2_desc">首席律师 专业的法律服务平台</div>
    <div class="b2_btn text_hover_shou">律师入驻</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.homebanner2 {
  width: 100%;
  height: 230px;
  background-image: url("~assets/home/banner2.png");
  padding-top: 35px;

  .b2_title {
    font-size: 48px;
    font-family: SJzhengjihei;
    font-weight: 400;
    line-height: 48px;
    color: #ffffff;
  }
  .b2_desc {
    font-size: 31px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    margin-top: 15px;
    color: #ffffff;
  }
  .b2_btn {
    width: 140px;
    height: 38px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    background-color: #fff;
    margin: 16px auto;
    color: #0465ea;
    line-height: 38px;
  }
}
</style>